import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import SummaryField from 'components/common/SummaryField'
import Columns from 'components/common/Columns/Columns'
import Section from '../../../Section'
import StepperActionBar from '../StepperActionBar'
import { DEFAULT_TITLE, INNER_PROPS } from './constants'
import { STEP_INDEXES } from '../../constants'
import { SectionWrapper, ActionBarWrapper } from '../common'

const Review = ({
  currentStepIndex,
  isPrevPageVisible,
  title = DEFAULT_TITLE,
  selectedServices,
  selectedVehicle,
  selectedStore,
  selectedDateTime,
  selectedContactInfo,
  onPrevPage,
  productPlaceholder,
  sendAppointment,
  setCurrentStepIndex
}) =>
  <React.Fragment>
    <SectionWrapper>
      <Section title={ title }>
        <Summary>
          <CustomColumns width="50% 50%" adaptive>
            <Fragment>
              <Field
                data-at-summary-vehicle-selector
                asset="car-red"
                medium
                info={ selectedVehicle }
                innerProps={ INNER_PROPS }
                link="Select Vehicle"
                title="I’d like to bring my"
                padding={ 80 }
                onClick={ () => setCurrentStepIndex(STEP_INDEXES.selectVehicle) } />
              <Field
                data-at-summary-select-location
                asset="location-red"
                medium
                title="to"
                info={ selectedStore }
                link="Select Location"
                padding={ 80 }
                onClick={ () => setCurrentStepIndex(STEP_INDEXES.selectLocation) } />
              <Field
                data-at-summary-contact-info
                asset="contact-red"
                medium
                title="contact"
                info={ selectedContactInfo }
                link="Contact Info"
                padding={ 80 }
                onClick={ () => setCurrentStepIndex(STEP_INDEXES.selectContactInfo) } />
            </Fragment>
            <Fragment>
              <Field
                data-at-summary-product
                asset="service-red"
                medium
                title="for"
                info={ selectedServices }
                link={ productPlaceholder }
                padding={ 80 }
                onClick={ () => setCurrentStepIndex(STEP_INDEXES.selectServices) } />
              <Field
                data-at-summary-select-data
                asset="calendar-red"
                medium
                title="drop-off at"
                info={ selectedDateTime }
                link="Select Date & Time"
                padding={ 80 }
                onClick={ () => setCurrentStepIndex(STEP_INDEXES.selectDatetime) } />
            </Fragment>
          </CustomColumns>
        </Summary>
        <StyledActionBarWrapper>
          <StepperActionBar
            isPrevPageVisible={ isPrevPageVisible }
            prevPageClick={ onPrevPage }
            hasPrevPage
            currentStepIndex={ currentStepIndex }
            requestAppointmentClick={ () => sendAppointment(setCurrentStepIndex) } />
        </StyledActionBarWrapper>
      </Section>
    </SectionWrapper>


  </React.Fragment>

Review.propTypes = {
  currentStepIndex: PropTypes.number,
  isPrevPageVisible: PropTypes.bool,
  onPrevPage: PropTypes.func,
  productPlaceholder: PropTypes.string,
  selectedContactInfo: PropTypes.node,
  selectedDateTime: PropTypes.string,
  selectedServices: PropTypes.string,
  selectedStore: PropTypes.string,
  selectedVehicle: PropTypes.string,
  sendAppointment: PropTypes.func,
  setCurrentStepIndex: PropTypes.func,
  title: PropTypes.string
}

export default Review

const Summary = styled.div`
  ${Media.desktop`
    margin: -5px -12px 0;
  `}
  ${Mixin.responsive('padding', '0', '5px 0 25px')}
`

const Field = styled(SummaryField)`
  ${Mixin.responsive('margin', '0 12px 40px', '0 0 15px')}
`

const CustomColumns = styled(Columns)`
  table-layout: fixed;
`

const StyledActionBarWrapper = styled(ActionBarWrapper)`
  ${Media.desktop`
    margin-left: 60px;
    padding-top: 0;
  `}
`
